import { ApplicationInsights } from '@microsoft/applicationinsights-web';

//const connectionString = process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;
//TEST 
//const connectionString = "InstrumentationKey=e7b4e5af-420a-44ac-9a62-ebdd745eded8;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=779dc4d2-b923-4bb4-9605-6938c41b015d"
//PROD
const connectionString = "InstrumentationKey=3803b8a3-ec01-444a-a009-6582d7281e0d;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=bbf7da55-161b-4ff2-b7a6-11520f10a2a8";
//const connectionString = "InstrumentationKey=3803b8a3-ec01-444a-a009-6582d7281e0d;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=bbf7da55-161b-4ff2-b7a6-11520f10a2a8";
export const appInsights = new ApplicationInsights({
  config: {
    connectionString,
    
    enableAutoRouteTracking: false, // Disabilita il tracking automatico delle route di React Router
    enableCorsCorrelation: false, // Disabilita la correlazione CORS
    enableRequestHeaderTracking: false, // Disabilita il tracking degli header delle richieste
    enableResponseHeaderTracking: false, // Disabilita il tracking degli header delle risposte
    disableFetchTracking: true, // Disabilita il tracking delle chiamate fetch
    disableAjaxTracking: true, // Disabilita il tracking delle chiamate AJAX
    enableUnhandledPromiseRejectionTracking: false, // Disabilita il tracking delle promise rejection non gestite
   // endpointUrl: 'https://westeurope-5.in.applicationinsights.azure.com/'
  },
});

export const initializeAppInsights = () => {
  if (connectionString) {
    appInsights.loadAppInsights();
  }
};

// Funzione per tracciare payload completi (tutti gli ambienti)
export const trackFullPayload = (eventName: string, payload: any, properties?: Record<string, any>) => {
  // Traccia sempre i metadati
  appInsights.trackEvent({
    name: eventName,
    properties: {
      payloadSize: JSON.stringify(payload).length,
      payloadSizeBytes: JSON.stringify(payload).length,
      ...properties
    },
    measurements: {
      payloadSizeBytes: JSON.stringify(payload).length
    }
  });

  // Traccia il payload completo in tutti gli ambienti
  appInsights.trackEvent({
    name: `${eventName}_Full`,
    properties: {
      fullPayload: JSON.stringify(payload),
      environment: process.env.NODE_ENV,
      ...properties
    }
  });
};

// Funzioni per tracciare l'user flow
export const trackUserFlow = {
  // Traccia l'inizio di una sessione o flusso
  startFlow: (flowName: string, properties?: Record<string, any>) => {
    appInsights.trackEvent({
      name: 'UserFlow_Started',
      properties: {
        flowName,
        timestamp: new Date().toISOString(),
        ...properties
      }
    });
  },

  // Traccia un passaggio nel flusso
  trackStep: (flowName: string, stepName: string, properties?: Record<string, any>) => {
    appInsights.trackEvent({
      name: 'UserFlow_Step',
      properties: {
        flowName,
        stepName,
        timestamp: new Date().toISOString(),
        ...properties
      }
    });
  },

  // Traccia il completamento di un flusso
  completeFlow: (flowName: string, properties?: Record<string, any>) => {
    appInsights.trackEvent({
      name: 'UserFlow_Completed',
      properties: {
        flowName,
        timestamp: new Date().toISOString(),
        ...properties
      }
    });
  },

  // Traccia l'abbandono di un flusso
  abandonFlow: (flowName: string, reason?: string, properties?: Record<string, any>) => {
    appInsights.trackEvent({
      name: 'UserFlow_Abandoned',
      properties: {
        flowName,
        reason,
        timestamp: new Date().toISOString(),
        ...properties
      }
    });
  },

  // Traccia la navigazione tra pagine
  trackNavigation: (fromPage: string, toPage: string, properties?: Record<string, any>) => {
    appInsights.trackEvent({
      name: 'UserFlow_Navigation',
      properties: {
        fromPage,
        toPage,
        timestamp: new Date().toISOString(),
        ...properties
      }
    });
  },

  // Traccia l'interazione con elementi UI
  trackInteraction: (elementType: string, elementName: string, action: string, properties?: Record<string, any>) => {
    appInsights.trackEvent({
      name: 'UserFlow_Interaction',
      properties: {
        elementType,
        elementName,
        action,
        timestamp: new Date().toISOString(),
        ...properties
      }
    });
  }
}; 